<template>
  <div class="animated fadeIn" v-if="!pageLoading">
    <loading v-if="vLoading" />
    <v-col lg="12" class="ml-auto"></v-col>
    <i
      hidden
      class="mr-3 fa fa-question-circle text-dark"
      @click="toggleHelp()"
      v-shortkey.once="['q']"
      @shortkey="toggleHelp()"
    ></i>
    <v-dialog v-model="guide" persistent width="700">
      <v-card>
        <v-card-title class="text-center">
          <h4>
            برای استفاده بهتر از این صفحه میتوانید از کلیدهای زیر استفاده کنید
          </h4>
        </v-card-title>
        <v-card-text>
          <v-btn elevation="6" outlined small>S</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          ذخیره پیش‌نویس <br /><br />
          <v-btn elevation="6" outlined small>P</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          نسخه چاپی استعلام <br /><br />
          <v-btn elevation="6" outlined small>q</v-btn>
          +
          <v-btn elevation="6" outlined small>Ctrl</v-btn>
          بروزرسانی موجودی <br /><br />
          <v-btn elevation="6" outlined small>Shift</v-btn> ورود به حالت تعیین
          قیمت و بالعکس <br /><br />
          <v-btn elevation="6" outlined small>+</v-btn> افزودن محصول جدید
        </v-card-text>
        <v-card-subtitle>
          <hr />

          <v-btn elevation="6" outlined small>q</v-btn> بستن این راهنما
        </v-card-subtitle>
      </v-card>
    </v-dialog>
    <div
      v-if="
        role == 'Manager' ||
        role == 'salesManager' ||
        role == 'trade' ||
        role == 'tradeHead'
      "
      active
    >
      <b-card>
        <template v-slot:header>
          <v-row :class="customer.customer_priority">
            <v-col cols="7" class="mt-4">
              <h4>کد پرونده: {{ orderInfo.orderCode }}</h4>

              <h5>نام مشتری: {{ orderInfo.customerName }}</h5>
              <h5>رتبه مشتری: {{ orderInfo.customer_priority }}</h5>
              <h5>شماره درخواست مشتری: {{ orderInfo.originalRequestId }}</h5>
              <h5>
                نوع استعلام:
                {{
                  orderTypes.filter((x) => x.value == orderInfo.orderType)[0]
                    .text
                }}
              </h5>
            </v-col>
            <v-col cols="5" class="mt-4">
              <v-col>
                <v-row>
                  <v-col>
                    <h4>وضعیت پرونده: {{ orderInfo.status }}</h4>
                    <h5>تاریخ ثبت استعلام: {{ orderInfo.registerDate }}</h5>
                    <h5>ثبت اولیه توسط: {{ orderInfo.ownerName }}</h5>
                    <h5>
                      کارشناس بازرگانی:
                      {{ orderInfo.assigneeName }}
                    </h5>
                  </v-col>
                </v-row>
              </v-col>
            </v-col>
          </v-row>
        </template>

        <b-card
          class="shadow mb-5 bg-white rounded"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template v-slot:header>
            <v-row>
              <v-col cols="4">
                <h6 style="display: inline">اقلام قبلی</h6>
              </v-col>
            </v-row>
          </template>

          <v-row class="mb-3">
            <v-col cols="12">
              <div
                v-html="orderInfo.customerTerms"
                style="border: 1px solid black"
                class="p-1 rounded"
              />
            </v-col>
          </v-row>

          <b-table
            small
            responsive
            show-empty
            :items="filtered"
            :fields="fieldsCI"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.index + 1 }}
                <br />
                <!-- <b-form-checkbox
                    v-model="selectedItems[data.index]"
                  ></b-form-checkbox> -->
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                <v-btn color="success" @click="addingToNewTable(data.item)"
                  >افزودن</v-btn
                >
              </div>
            </template>

            <template v-slot:cell(totalPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                {{ (data.item.perPrice * data.item.number).toLocaleString() }}
              </div>
            </template>
          </b-table>
          <v-row class="mb-3">
            <v-col cols="5"
              >قیمت اقلام:
              {{
                orderInfo.orderItems.length > 0
                  ? sarmadNumber2(
                      orderInfo.orderItems
                        .map(
                          (x) =>
                            (x.perPrice
                              ? String(x.perPrice).replace(/\s/g, "")
                              : 0) *
                            (x.number ? String(x.number).replace(/\s/g, "") : 0)
                        )
                        .reduce((a, b) => a + b)
                    )
                  : "--"
              }}
              {{ orderInfo.currency }}
            </v-col>
            <v-col cols="1"></v-col>
            <v-col cols="2">واحد پول:</v-col>
            <v-col cols="3">
              {{ orderInfo.currency }}
            </v-col>
          </v-row>

          <hr />
          <v-row>
            <v-col cols="12">
              <div
                v-html="orderInfo.terms"
                style="border: 1px solid black"
                class="p-2 rounded"
              />
            </v-col>
          </v-row>
          <hr />
          <a
            class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
            style="float: right"
            :href="'/' + role + '/order/' + $route.params.id"
            target="_blank"
          >
            مشاهده پرونده سفارش
          </a>
        </b-card>

        <br />
        <b-card class="shadow p-3 mb-5 bg-white rounded">
          <div class="ma-0 pa-0" style="margin-top: -30px !important">
            <v-switch v-model="hasCustomerIndex" label="ردیف مشتری"></v-switch>
          </div>
          <b-textarea
            type="text"
            rows="6"
            max-rows="10"
            v-model="batchText"
            placeholder="لطفا داده‌ها را از اکسل کپی کنید و دکمه تحلیل را بزنید. سپس از جدول حاصل میتوانید المان‌های مورد نظر را به جدول اصلی بیافزایید."
          />
          <br />
          <v-row>
            <b-btn
              variant="success"
              class="mr-1"
              @click="analyzeBatch()"
              style="float: left"
              >تحلیل</b-btn
            >
            <b-btn
              variant="danger"
              class="mr-1"
              @click="delAnalyzeBatch()"
              style="float: left"
              >حذف نتایج</b-btn
            >
          </v-row>
        </b-card>
        <b-card v-if="showBatchTable" class="shadow p-3 mb-5 bg-white rounded">
          <b-table
            responsive
            v-if="showBatchTable"
            show-empty
            :items="batchData"
            :fields="fieldsHistory"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            striped
          >
            <template v-slot:head()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div style="text-align: center; vertical-align: middle">
                {{ data.value }}
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div>
                <b-btn
                  variant="danger"
                  class="mr-2"
                  @click="delBatch(data.index)"
                  >x</b-btn
                >
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div style="text-align: center; vertical-align: middle">
                <b-btn
                  variant="success"
                  class="mr-1"
                  @click="addingToNewTable(data.item)"
                  >افزودن</b-btn
                >
              </div>
            </template>
            <template v-slot:cell(totalPrice)="data">{{
              (data.item.perPrice * data.item.number).toLocaleString()
            }}</template>

            <div slot="table-busy" class="text-center text-danger my-2">
              <strong>در حال بارگذاری...</strong>
              <br />
              <b-spinner class="align-middle"></b-spinner>
            </div>
          </b-table>
          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="doBatchAdd()"
            >افزودن همه</b-btn
          >
        </b-card>
        <b-card
          class="shadow mb-5 bg-white rounded"
          header-bg-variant="primary"
          header-text-variant="white"
        >
          <template v-slot:header>
            <v-row>
              <v-col cols="4">
                <h6 style="display: inline">اقلام جدید سفارش</h6>
              </v-col>
            </v-row>
          </template>

          <b-table
            small
            responsive
            show-empty
            :items="newItem"
            :fields="
              hasCustomerIndex
                ? myFields
                : myFields.filter((x) => x.key != 'customerIndex')
            "
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(index)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ filtered.length + data.index + 1 }}
              </div>
            </template>
            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                <v-btn
                  class="red white--text"
                  @click="deleteItemRowOrder(data.item, data.index)"
                  >delete</v-btn
                >
              </div>
            </template>
            <template v-slot:cell(selected)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-btn
                  variant="warning"
                  class="m-1"
                  @click="
                    analyzeItem(data.item, filtered.length + data.index + 1)
                  "
                  >تحلیل</b-btn
                >
              </div>
            </template>

            <template v-slot:cell(totalPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                {{ (data.item.perPrice * data.item.number).toLocaleString() }}
              </div>
            </template>

            <template v-slot:cell(perPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <vuetify-money
                  v-model="data.item.perPrice"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                  outlined
                  dense
                />
                <br />
                <!-- <span>{{ sarmadNumber2(data.item.perPrice) }}</span> -->
              </div>
            </template>

            <template v-slot:cell(number)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <v-text-field
                  v-model="data.item.number"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>

            <template v-slot:cell(customerIndex)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <v-text-field
                  v-model="data.item.customerIndex"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>

            <template v-slot:cell(length)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.length"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(diameter)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.diameter"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(dimensionStandard)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.dimensionStandard"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(cover)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.cover"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(details)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.details"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(material)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.material"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(description)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.description"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
          </b-table>

          <b-btn variant="success" class="mb-4" @click="analyzeAll()"
            >تحلیل همه اقلام</b-btn
          >
          <b-btn variant="primary" class="mb-4 ms-4" @click="addItem()"
            >افزودن سطر جدید</b-btn
          >

          <hr />

          <h6 class="font-weight-bold my-3">اقلام جدید تولید:</h6>

          <b-table
            small
            responsive
            show-empty
            :items="analyzedItem"
            :fields="myAnalyzedFields"
            empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
            empty-text="رکوردی برای نمایش وجود ندارد"
            class="table table-secondary"
          >
            <template v-slot:head()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.label }}
              </div>
            </template>
            <template v-slot:cell()="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                {{ data.value }}
              </div>
            </template>

            <template v-slot:cell(operation)="data">
              <div
                style="
                  text-align: center;
                  vertical-align: middle;
                  font-family: Tahoma;
                "
              >
                <v-btn
                  class="red white--text"
                  @click="deleteItemRowProduce(data.item, data.index)"
                  >delete</v-btn
                >
              </div>
            </template>

            <template v-slot:cell(totalPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                {{ (data.item.perPrice * data.item.number).toLocaleString() }}
              </div>
            </template>

            <template v-slot:cell(perPrice)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <vuetify-money
                  v-model="data.item.perPrice"
                  :valueWhenIsEmpty="valueWhenIsEmpty"
                  :options="perPriceOptions"
                  type="number"
                  outlined
                  dense
                />
                <br />
                <!-- <span>{{ sarmadNumber2(data.item.perPrice) }}</span> -->
              </div>
            </template>

            <template v-slot:cell(number)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <v-text-field
                  v-model="data.item.number"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>
            <template v-slot:cell(index)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <v-text-field
                  v-model="data.item.index"
                  type="number"
                  outlined
                  dense
                ></v-text-field>
              </div>
            </template>

            <template v-slot:cell(length)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.length"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(diameter)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.diameter"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(dimensionStandard)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.dimensionStandard"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(cover)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.cover"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(details)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.details"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(material)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.material"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
            <template v-slot:cell(description)="data">
              <div dir="ltr" style="font-family: Tahoma">
                <b-form-textarea
                  v-model="data.item.description"
                  type="text"
                  rows="6"
                  max-rows="6"
                ></b-form-textarea>
              </div>
            </template>
          </b-table>

          <b-btn variant="primary" class="mb-4" @click="addItemToAnalysedItem()"
            >افزودن سطر جدید</b-btn
          >
          <hr />
          <a
            class="btn btn-primary mr-1 ml-2 mb-3 mt-0 text-white"
            style="float: right"
            :href="'/' + role + '/order/' + $route.params.id"
            target="_blank"
          >
            مشاهده پرونده سفارش
          </a>

          <b-btn
            variant="success"
            class="mr-1"
            style="float: left"
            @click="addItemsToOrder()"
            >افزودن اقلام</b-btn
          >
        </b-card>
      </b-card>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Axios from "axios";
import moment from "moment-jalaali";
import router from "../../router";

import prices from "../../mixins/prices";

export default {
  mixins: [prices],
  components: {},
  data: function () {
    return {
      batchText: "",
      guide: false,
      selectedItems: [],
      newItem: [],
      analyzedItem: [],
      editSelectedModal: false,
      bulkEditFrom: "",
      bulkEditTo: "",
      valueWhenIsEmpty: "0",
      options: {
        decimal: ".",
        thousands: ",",
        precision: 0,
        min: 0,
      },
      role: "",
      followContent: "",
      getContent: "",
      sendBackReason: "",
      rejectReason: "",
      items: [],
      filter: null,
      isBusy: false,
      isBusy2: false,
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      itemsHistory: [],
      multiplier: 0,
      multiplierCount: 0,
      fields: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fields2: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen: [
        { key: "operation", label: "operation" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsCI: [
        { key: "operation", label: "افزودن به جدول جدید" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      fields2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsenCI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "dimensionStandard", label: "Standard Size" },
        { key: "cover", label: "Cover" },
        { key: "material", label: "Grade / Material" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsen2CI: [
        { key: "operation", label: "" },
        { key: "details", label: "Extra Details" },
        { key: "totalPrice", label: "Total Price" },
        { key: "perPrice", label: "Unit Price" },
        { key: "number", label: "Quantity" },
        { key: "length", label: "Length" },
        { key: "diameter", label: "Diameter" },
        { key: "description", label: "Description" },
        { key: "customerIndex", label: "Customer Index" },
        { key: "selected", label: "انتخاب" },
        { key: "index", label: "#" },
      ],
      fieldsAnalyze: [
        { key: "operation", label: "عملیات" },
        { key: "type", label: "نوع کالا" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "index", label: "#" },
      ],
      fieldsAnalyzeCI: [
        { key: "operation", label: "عملیات" },
        { key: "type", label: "نوع کالا" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "totalPrice", label: "قیمت کل" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "index", label: "#" },
      ],
      warehouseItems: [],
      warehouseFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      warehouseSingleFields: [
        { key: "index", label: "#" },
        { key: "inventory", label: "تعداد موجودی" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
      ],
      filtersWarehouse: [],
      currentWarehousePage: 1,
      perPageWarehouse: 25,
      totalRowsWarehouse: 0,
      isBusyWarehouse: false,
      isBusySingleWarehouse: false,
      analyzeOneItemModal: false,
      selectedItem: {},
      fieldsHistory2: [
        { key: "index", label: "#" },
        { key: "details", label: "توضیحات تکمیلی" },
        { key: "customerIndex", label: "ردیف مشتری" },
        { key: "currency", label: "واحد پول" },
        { key: "perPrice", label: "قیمت واحد" },
        { key: "number", label: "واحد" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "cover", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "operation", label: "پرونده استعلام" },
      ],
      formTemplates: [
        { value: "pk1", text: "الگوی PK1 فارسی" },
        { value: "pk2", text: "الگوی PK2 فارسی" },
        { value: "pken", text: "الگوی PK1 انگلیسی" },
        { value: "pken2", text: "الگوی PK2 انگلیسی" },
      ],
      measurementUnit: "",
      measurementUnits: [
        { value: "تعداد", text: "تعداد" },
        { value: "کیلوگرم", text: "کیلوگرم" },
        { value: "تن", text: "تن" },
      ],
      formTemplate: "",
      currencyOptions: [
        { value: "دلار", text: "دلار", precision: 2 },
        { value: "USD", text: "USD", precision: 2 },
        { value: "$", text: "$", precision: 2 },
        { value: "یورو", text: "یورو", precision: 2 },
        { value: "Euro", text: "Euro", precision: 2 },
        { value: "€", text: "€", precision: 2 },
        { value: "ریال", text: "ریال", precision: 0 },
        { value: "Rials", text: "Rials", precision: 0 },
        { value: "یوآن", text: "یوآن", precision: 2 },
        { value: "Yuan", text: "Yuan", precision: 2 },
        { value: "¥", text: "¥", precision: 2 },
        { value: "درهم", text: "درهم", precision: 2 },
      ],
      orderTypes: [
        { value: "full", text: "مالی" },
        { value: "technical", text: "فنی" },
      ],
      currency: "",
      hasCustomerIndex: false,
      hasSizeStandard: true,
      allOrders: [],
      config: {
        toolbar: [
          [
            "Bold",
            "Italic",
            "Underline",
            "Strike",
            "Subscript",
            "Superscript",
            "TextColor",
          ],
        ],
        height: 200,
      },
      purchaseTerms: "",
      striped: true,
      showPurchaseTemrs: true,
      showCustomerTerms: true,
      customerInfo: {},
      orderInfo: {},
      onlyChangePrice: false,
      filterFile: "",
      isBusyFile: false,
      itemsFile: [],
      fieldsFile: [
        { key: "index", label: "#" },
        { key: "date", label: "تاریخ آپلود" },
        { key: "name", label: "نام فایل" },
        // { key: "subject", label: "توضیحات" },
        { key: "uploaderName", label: "فرد بارگذاری کننده" },
        { key: "download", label: "دریافت" },
      ],
      journals: [],
      filters: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      filtersHistory: {
        details: "",
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
        index: "",
        operation: "",
      },
      deleteDialog: false,
      sendMethods: [
        "پاکت دربسته",
        "ایمیل",
        "فاکس",
        "واتساپ",
        "سایر روش‌ها (در توضیحات ذکر شود)",
      ],
      sendMethod: "",
      showProgress: false,
      uploadButDisable: false,
      variant: "info",
      striped: true,
      max: 100,
      uploadPercentage: 0,
      isUploaded: false,
      file: "",
      response: "none",
      responses: [
        {
          value: "none",
          text: "پاسخی دریافت نشده است",
          status: "در انتظار نظر مشتری",
        },
        {
          value: "yes",
          text: "با تعیین قیمت موافقم",
          status: "تایید تعیین قیمت توسط مشتری",
        },
        {
          value: "no",
          text: "با تعیین قیمت مخالفم",
          status: "رد تعیین قیمت توسط مشتری",
        },
        {
          value: "revision",
          text: "تعیین قیمت نیاز به بازبینی دارد",
          status: "بازبینی تعیین قیمت",
        },
      ],
      customerHistory: [],
      orderVat: 0,
      packagingCost: 0,
      transportCost: 0,
      personCost: 0,
      coatingCost: 0,
      otherCost: 0,
      certificationCost: 0,
      discount: 0,
      customerOrders: [],
      ordersTotalRows: 0,
      staticOrdersTotalRows: 0,
      agents: [],
      agentsTotalRows: 0,
      staticAgentsTotalRows: 0,
      customer: {},
      customerOrdersFields: [
        { key: "index", label: "ردیف" },
        { key: "orderCode", label: "کد استعلام" },
        { key: "originalRequestId", label: "شماره درخواست" },
        { key: "registerDate", label: "تاریخ" },
        { key: "status", label: "وضعیت" },
      ],
      customerOrdersIsBusy: true,
      customerOrdersFilter: null,
      currentPageOrder: 1,
      agentsFilter: null,
      agentsIsBusy: true,
      currentPageContact: 1,
      agentsFields: [
        { key: "index", label: "ردیف" },
        { key: "name", label: "نام رابط" },
        { key: "internal", label: "داخلی" },
        { key: "role", label: "سمت" },
        { key: "phone", label: "تلفن" },
        { key: "phone2", label: "تلفن 2" },
        { key: "fax", label: "فاکس" },
        { key: "mobile", label: "موبایل" },
        { key: "email", label: "ایمیل" },
        { key: "address", label: "آدرس" },
        { key: "postalCode", label: "کد پستی" },
        // { key: "operation", label: "عملیات" },
      ],
      replaceFields: [
        { key: "details", label: "توضیحات تکمیلی", value: false },
        { key: "number", label: "واحد", value: false },
        { key: "length", label: "طول", value: false },
        { key: "diameter", label: "قطر", value: false },
        { key: "dimensionStandard", label: "استاندارد ابعاد", value: false },
        { key: "cover", label: "پوشش", value: false },
        { key: "material", label: "متریال", value: false },
        { key: "description", label: "شرح کالا", value: false },
      ],
      updateAllItems: [
        {
          details: "",
          number: "",
          length: "",
          diameter: "",
          dimensionStandard: "",
          cover: "",
          material: "",
          description: "",
        },
      ],
      updateTableBusy: false,
      vLoading: false,
      pageLoading: false,
      batchData: [],
      showBatchTable: false,
      originalOrderFields: [
        // { key: "itemCode", label: "شماره سفارش" },
        // { key: "type", label: "نوع کالا" },
        // { key: "priority", label: "اولویت" },
        // { key: "notes", label: "توضیحات تکمیلی" },
        { key: "palletNo", label: "شماره پالت" },
        { key: "boxNo", label: "شماره جعبه" },
        { key: "netWeight", label: "وزن خالص" },
        { key: "grossWeight", label: "وزن غیرخالص" },
        { key: "remarks", label: "نکات تکمیلی" },
        { key: "packingDescription", label: "توضیحات بسته‌بندی" },
        { key: "packingType", label: "نوع بسته‌بندی" },
        { key: "boxCount", label: "تعداد جعبه" },
        { key: "qty", label: "تعداد تحویل" },
        { key: "previousQTY", label: "تعداد قبلی" },
        { key: "number", label: "تعداد کل" },
        { key: "length", label: "طول" },
        { key: "diameter", label: "قطر" },
        { key: "dimensionStandard", label: "استاندارد ابعاد" },
        { key: "coating", label: "پوشش" },
        { key: "material", label: "متریال" },
        { key: "description", label: "شرح کالا" },
        { key: "mapNumber", label: "شماره نقشه" },
        { key: "customerIndex", label: " ردیف مشتری" },
        { key: "index", label: "ردیف" },
      ],
      orderItems: [],
    };
  },

  methods: {
    addingToNewTable(item) {
      let myItem = JSON.parse(JSON.stringify(item));
      this.newItem.push(myItem);
    },
    deleteItemRowOrder(item, id) {
      this.newItem = this.newItem.filter((data, index) => index != id);
    },
    deleteItemRowProduce(item, id) {
      console.log(item);
      this.analyzedItem = this.analyzedItem.filter(
        (data, index) => index != id
      );
    },
    analyzeAll() {
      this.vLoading = true;
      var myAllItems = this.newItem;
      myAllItems = myAllItems
        .map((x) => x.description.split("&"))
        .reduce((a, b) => a.concat(b), []);
      setTimeout(() => {
        this.newItem.forEach((item, index) => {
          this.analyzeItem(item, this.filtered.length + index + 1);
          this.vLoading = false;
        });
      }, 500);
    },
    delBatch(order) {
      this.batchData.splice(order, 1);
    },
    analyzeBatch() {
      let batchDataArray = this.batchText.split(",").join("").split("\n");
      if (this.hasSizeStandard) {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                perPrice: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                number: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                length: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                diameter: x.split("\t")[2]
                  ? x.split("\t")[2].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[10] ? x.split("\t")[10].trim() : "",
                perPrice: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                number: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                length: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                diameter: x.split("\t")[5]
                  ? x.split("\t")[5].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[4]
                  ? x.split("\t")[4].trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                perPrice: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                number: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                length: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                diameter: x.split("\t")[1]
                  ? x.split("\t")[1].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                dimensionStandard: x.split("\t")[3]
                  ? x.split("\t")[3].trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      } else {
        if (this.hasCustomerIndex) {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsCI;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2CI;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[9] ? x.split("\t")[9].trim() : "",
                perPrice: x.split("\t")[7] ? x.split("\t")[7].trim() : "",
                number: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                length: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                diameter: x.split("\t")[4]
                  ? x.split("\t")[4].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[3] ? x.split("\t")[3].trim() : "",
                material: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                description: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                customerIndex: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsenCI;
          }
        } else {
          if (this.formTemplate == "pk1") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields;
          } else if (this.formTemplate == "pk2") {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fields2;
          } else {
            this.batchData = batchDataArray.map((x) => {
              return {
                details: x.split("\t")[8] ? x.split("\t")[8].trim() : "",
                perPrice: x.split("\t")[6] ? x.split("\t")[6].trim() : "",
                number: x.split("\t")[5] ? x.split("\t")[5].trim() : "",
                length: x.split("\t")[4] ? x.split("\t")[4].trim() : "",
                diameter: x.split("\t")[3]
                  ? x.split("\t")[3].replace(/\s+/g, " ").trim()
                  : "",
                cover: x.split("\t")[2] ? x.split("\t")[2].trim() : "",
                material: x.split("\t")[1] ? x.split("\t")[1].trim() : "",
                description: x.split("\t")[0] ? x.split("\t")[0].trim() : "",
              };
            });

            this.fieldsHistory = this.fieldsen;
          }
        }
      }

      this.showBatchTable = true;
    },
    delAnalyzeBatch() {
      this.batchData = [];
      this.showBatchTable = false;
    },
    doBatchAdd() {
      // this.orderInfo.orderItems = this.orderInfo.orderItems.concat(
      //   this.batchData
      // );
      this.newItem = this.newItem.concat(this.batchData);
      this.batchText = "";
      this.batchData = [];
      this.showBatchTable = false;
      this.showBatchArea = false;
    },
    toggleCustomerTerms() {
      this.showCustomerTerms = !this.showCustomerTerms;
    },
    addItemsToOrder() {
      Axios.post(
        this.baseUrl + "/ppkpms/factory/order/addNewItems",
        {
          orderId: this.$route.params.id,
          orderItems: this.newItem,
          items: this.analyzedItem,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getTaskInfo();
            this.newItem = [];
            this.analyzedItem = [];
            this.batchData = [];
            this.batchText = "";
            this.toast(res.data, "success");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    getTaskInfo() {
      this.vLoading = true;
      this.pageLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/order/getInfo",
        {
          orderId: this.$route.params.id,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.isBusy = false;
          if (res.status == 200) {
            this.vLoading = false;
            this.pageLoading = false;
            this.orderInfo = res.data;
            // console.log(this.orderInfo);
            this.orderInfo.orderItems = JSON.parse(this.orderInfo.orderItems);
            if (!res.data.hasCustomerIndex) {
              this.originalOrderFields = this.originalOrderFields.filter(
                (x) => x.key != "customerIndex"
              );
            }
            // console.log(this.orderInfo.orderItems);
            this.orderItems = this.orderInfo.orderItems;
            this.orderItems.forEach((service) => {
              if (service.status == "توقف موقت تولید") {
                service._rowVariant = "danger";
              }
            });
            this.history = this.orderInfo.factoryHistory;
            this.factoryOrderFiles = this.orderInfo.factoryFiles
              ? JSON.parse(this.orderInfo.factoryFiles)
              : "";
            this.totalRows = this.orderItems.length;
          } else {
            this.toast("مشکلی پیش آمده. مجددا امتحان کنید.", "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.vLoading = false;
          this.pageLoading = false;
          this.toast("خطا: " + err.response, "error");
        });
    },
    toggleHelp() {
      this.guide = !this.guide;
    },

    sarmadNumber2(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";

      try {
        let temp1 = parseFloat(data).toFixed(
          this.currencyOptions.filter(
            (x) => x.value == this.orderInfo.currency
          )[0].precision
        );
        return parseFloat(temp1) ? parseFloat(temp1).toLocaleString() : "--";
      } catch (error) {
        return "--";
      }
    },

    submitQuote() {
      Axios.post(
        this.baseUrl + "/ppkpms/order/submitQuote",
        {
          orderId: this.$route.params.id,
          productsTemplate: this.formTemplate,
          measurementUnit: this.measurementUnit,
          customerTerms: this.orderInfo.customerTerms,
          terms: this.purchaseTerms,
          orderItems: JSON.stringify(this.orderInfo.orderItems),
          hasCustomerIndex: this.hasCustomerIndex,
          hasSizeStandard: this.hasSizeStandard,
          orderVat: this.orderVat || 0,
          packagingCost: this.packagingCost || 0,
          transportCost: this.transportCost || 0,
          personCost: this.personCost || 0,
          certificationCost: this.certificationCost || 0,
          coatingCost: this.coatingCost || 0,
          otherCost: this.otherCost || 0,
          discount: this.discount || 0,
          currency: this.currency,
          // note:this.purchaseTerms
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.toast("عملیات موفق", "success");
            router.push("/" + this.role + "/dashboard/");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
        });
    },

    sarmadNumber(data) {
      if (data == "اشکالی در محاسبات وجود دارد. حاصل منفی شده است")
        return "اشکالی در محاسبات وجود دارد. حاصل منفی شده است";
      try {
        let temp1 = parseFloat(
          parseFloat(data).toFixed(
            this.currencyOptions.filter((x) => x.value == this.currency)[0]
              .precision
          )
        );
        return temp1 ? temp1 : 0;
      } catch (error) {
        return 0;
      }
    },

    addItem() {
      this.newItem.push({
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
      });
    },
    addItemToAnalysedItem() {
      this.analyzedItem.push({
        totalPrice: "",
        perPrice: "",
        number: "",
        length: "",
        diameter: "",
        dimensionStandard: "",
        cover: "",
        material: "",
        description: "",
        details: "",
        customerIndex: "",
      });
    },

    analyzeItem(item, index) {
      var myNumber = item.number;
      var myLength = item.length;
      var myDiameter = item.diameter;
      var myCover = item.cover;
      var myCustomerIndex = item.customerIndex;
      var myIndex = item.index;
      var myDetails = item.details;
      var myType = item.type;

      var myDescriptions = item.description.split("&");
      var myDimensionStandards = "";
      var myMaterials = "";
      try {
        myMaterials = item.material.split("&");
      } catch (error) {
        console.log(error, item);
        myMaterials = "";
      }
      try {
        myDimensionStandards = item.dimensionStandard.split("&");
      } catch (error) {
        console.log(error, item);
        myDimensionStandards = "";
      }

      if (myDescriptions.length > 1) {
        try {
          myDescriptions.forEach((element, index2) => {
            var finalDimensionStandards;
            var finalMaterials;
            var finalDescriptions;
            var finalNumber = myNumber;
            var finalLength = myLength;
            var finalType = myType;
            try {
              if (myDimensionStandards.length > 1)
                finalDimensionStandards = myDimensionStandards[index2].trim();
              else finalDimensionStandards = myDimensionStandards[0].trim();
            } catch (error) {
              console.log(error, item);
              finalDimensionStandards = "";
            }
            try {
              finalMaterials = myMaterials[index2].trim();
            } catch (error) {
              console.log(error, item);
              finalMaterials = "";
            }
            try {
              finalDescriptions = myDescriptions[index2].trim();
              if (/^\d$/.test(finalDescriptions[0])) {
                if (/^\d$/.test(finalDescriptions[1])) {
                  finalNumber =
                    finalNumber *
                    (10 * Number(finalDescriptions[0]) +
                      Number(finalDescriptions[1]));

                  finalDescriptions = finalDescriptions.substring(2).trim();

                  var descriptionLength = finalDescriptions.length;
                } else {
                  finalNumber = finalNumber * Number(finalDescriptions[0]);
                  finalDescriptions = finalDescriptions.substring(1).trim();

                  var descriptionLength = finalDescriptions.length;
                }
                if (finalDescriptions[descriptionLength - 1] == "S") {
                  finalDescriptions = finalDescriptions
                    .substring(0, descriptionLength - 1)
                    .trim();
                }
              }
            } catch (error) {
              console.log(error, item);
              finalDescriptions = "";
            }

            try {
              var tempDescription = finalDescriptions.toLowerCase();
              if (tempDescription.indexOf("nut") >= 0) {
                finalLength = "";
                finalType = "مهره";
              } else if (tempDescription.indexOf("washer") >= 0) {
                finalLength = "";
                finalType = "واشر";
              } else if (tempDescription.indexOf("plate") >= 0) {
                finalLength = "";
                finalType = "سایر";
              } else if (tempDescription.indexOf("sleeve") >= 0) {
                finalLength = "";
                finalType = "سایر";
              } else finalType = "پیچ";
            } catch (error) {
              // console.log(error, item);
            }

            this.analyzedItem.splice(index + index2 + 1, 0, {
              number: finalNumber,
              length: finalLength,
              diameter: item.diameter,
              dimensionStandard: finalDimensionStandards,
              cover: item.cover,
              material: finalMaterials,
              description: finalDescriptions.replace("HEX ", "HEX. "),
              details: item.details,
              customerIndex: item.customerIndex,
              type: finalType,
              perPrice: item.perPrice,
              index: parseInt(Number(index) * 10 + index2 + 1) / 10,
            });
          });
        } catch (error) {
          // console.log(error, item);
        }
      } else {
        try {
          var finalDescriptions = item.description.trim();
          var finalLength = item.length.trim();
          var finalType = "دست";
          var tempDescription = finalDescriptions.toLowerCase();
          if (tempDescription.indexOf("nut") >= 0) {
            finalLength = "";
            finalType = "مهره";
          } else if (tempDescription.indexOf("washer") >= 0) {
            finalLength = "";
            finalType = "واشر";
          } else if (tempDescription.indexOf("plate") >= 0) {
            finalLength = "";
            finalType = "سایر";
          } else if (tempDescription.indexOf("sleeve") >= 0) {
            finalLength = "";
            finalType = "سایر";
          } else finalType = "پیچ";

          this.analyzedItem.push({
            length: finalLength,
            diameter: item.diameter,
            dimensionStandard: item.dimensionStandard,
            cover: item.cover,
            material: item.material,
            description: item.description,
            details: item.details,
            customerIndex: item.customerIndex,
            number: item.number,
            perPrice: item.perPrice,
            type: finalType,
            index: parseInt(Number(index) * 10 + 1) / 10,
          });
          // this.analyzedItem[index].type = finalType;
          // this.analyzedItem[index].length = finalLength;
        } catch (error) {
          console.log(error, item);
        }
      }
    },
  },

  computed: {
    myFields() {
      let myfields = [];

      myfields = this.hasCustomerIndex
        ? this.formTemplate == "pk1"
          ? this.fieldsCI
          : this.formTemplate == "pk2"
          ? this.fields2CI
          : this.formTemplate == "pken2"
          ? this.fieldsen2CI
          : this.fieldsenCI
        : this.formTemplate == "pk1"
        ? this.fields
        : this.formTemplate == "pk2"
        ? this.fields2
        : this.formTemplate == "pken2"
        ? this.fieldsen2
        : this.fieldsen;

      if (!this.hasSizeStandard) {
        myfields = myfields.filter((x) => x.key != "dimensionStandard");
      }

      if (this.orderInfo.orderType == "technical") {
        myfields = myfields.filter((x) => x.key != "perPrice");
        myfields = myfields.filter((x) => x.key != "totalPrice");
      }

      return myfields;
    },

    myAnalyzedFields() {
      let myfields = [];

      myfields = this.hasCustomerIndex
        ? this.fieldsAnalyzeCI
        : this.fieldsAnalyze;

      // if (!this.hasSizeStandard) {
      //   myfields = myfields.filter((x) => x.key != "dimensionStandard");
      // }

      // myfields = myfields.filter((x) => x.key != "perPrice");
      // myfields = myfields.filter((x) => x.key != "totalPrice");

      return myfields;
    },

    perPriceOptions() {
      let myOptions = {
        decimal: ".",
        thousands: ",",
        precision: 0,
      };
      try {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: this.currencyOptions.filter(
            (x) => x.value == this.currency
          )[0].precision,
        };
      } catch (error) {
        myOptions = {
          decimal: ".",
          thousands: ",",
          precision: 0,
        };
      }
      return myOptions;
    },
    filtered() {
      const filtered = this.orderInfo
        ? this.orderInfo.orderItems.filter((item) => {
            return Object.keys(this.filters).every((key) =>
              String(item[key])
                .toLowerCase()
                .includes(this.filters[key].toLowerCase())
            );
          })
        : null;
      return filtered;
    },
  },
  created() {
    this.getTaskInfo();
    // this.addItem();
    this.role = window.localStorage.getItem("role");
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
</style>
<style scoped lang="scss">
textarea {
  padding: 2px !important;
}

hr {
  border: none;
  border-top: 3px double #333;
  color: #333;
  overflow: visible;
  text-align: center;
  height: 5px;
}

.VIP {
  background-color: rgb(150, 111, 13);
  color: white;
}

.معمولی {
  background-color: rgb(3, 25, 135);
  color: white;
}

.لیست {
  background-color: rgb(224, 10, 10);
  color: black;
}
</style>
